import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propShape } from '../../../../../helpers/custom-prop-types';
import { getViewName } from '../../../../../helpers/professional_my_page';
import { isEnableSolutionChange } from '../../../../../helpers/solution';
const OverViewManager = ({ profile, showModal, solution }) => (_jsx("div", Object.assign({ className: 'overview-manager' }, { children: _jsxs("dl", { children: [_jsx("dt", { children: "\u8CAC\u4EFB\u8005" }), _jsxs("dd", { children: [getViewName(profile, solution.representative), _jsx("button", Object.assign({ className: 'link-text modalBtn', disabled: !isEnableSolutionChange(solution, profile), onClick: showModal, type: 'button' }, { children: "\u5909\u66F4" }))] })] }) })));
OverViewManager.propTypes = {
    profile: propShape().isRequired,
    showModal: propFunc().isRequired,
    solution: propShape().isRequired,
};
export default OverViewManager;
